import { FeedbackArea } from './schema/FeedbackAreas';
import OwaWorkload from 'owa-workloads/lib/store/schema/OwaWorkload';
import { isFeatureEnabled } from 'owa-feature-flags';
import { hasQueryStringParameter } from 'owa-querystring';
import { getUserConfiguration } from 'owa-session-store';
import { lazyGetDebugLogAttachmentDetailsForTestArea } from './lazyGetDebugLogAttachmentDetailsForTestArea';

const feedbackQueryParamName = 'feedback';

const getFeedbackConfig = (): FeedbackArea[] =>
    [
        {
            displayName: 'Mail',
            emailAddresses: ['outlookwebfeedback@microsoft.com'],
            workloads: OwaWorkload.Mail,
            subAreas: [
                {
                    displayName: 'Folders',
                    emailAddresses: ['owatriage@microsoft.com'],
                    workloads: OwaWorkload.Mail,
                },
                {
                    displayName: 'List view',
                    emailAddresses: ['owatriage@microsoft.com'],
                    workloads: OwaWorkload.Mail,
                },
                {
                    displayName: 'Triage actions',
                    emailAddresses: ['owatriage@microsoft.com'],
                    workloads: OwaWorkload.Mail,
                },
                {
                    displayName: 'Reading pane',
                    emailAddresses: ['owareadingpane@service.microsoft.com', 'phloh@microsoft.com'],
                },
                {
                    displayName: 'Compose',
                    emailAddresses: ['owacompeng@microsoft.com', 'phloh@microsoft.com'],
                },
                {
                    displayName: 'Search',
                    emailAddresses: [
                        'owasearchfeaturecrew@service.microsoft.com',
                        'nathnovi@microsoft.com',
                    ],
                },
                {
                    displayName: 'Editor Proofing',
                    emailAddresses: ['editorproofinginowafeedback@service.microsoft.com'],
                },
            ],
        },
        isFeatureEnabled('notes-folder-view') && {
            displayName: 'Notes',
            emailAddresses: ['stickynotes@microsoft.com'],
            workloads: OwaWorkload.Mail,
        },
        {
            displayName: 'Calendar',
            emailAddresses: [
                'outlookwebfeedback@microsoft.com',
                'calendarreactfeedback@service.microsoft.com',
            ],
            getDebugLogAttachmentDetails: null /**TODO VSO 59901: Add debug information calendar surface feedback attachment details */,
            workloads: OwaWorkload.Calendar,
            subAreas: [
                { displayName: 'Adding an event', workloads: OwaWorkload.Calendar },
                { displayName: 'Creating a meeting', workloads: OwaWorkload.Calendar },
                { displayName: 'Scheduling', workloads: OwaWorkload.Calendar },
                {
                    displayName: 'Adding locations, rooms, or Skype',
                    workloads: OwaWorkload.Calendar,
                },
                {
                    displayName: 'Events from email (flights, packages ...)',
                    workloads: OwaWorkload.Calendar,
                },
                { displayName: 'Calendar sharing', workloads: OwaWorkload.Calendar },
                { displayName: 'Calendar views', workloads: OwaWorkload.Calendar },
                { displayName: 'Time zones', workloads: OwaWorkload.Calendar },
                { displayName: 'Holidays', workloads: OwaWorkload.Calendar },
                {
                    displayName: 'Interesting calendars and local events',
                    workloads: OwaWorkload.Calendar,
                },
                { displayName: 'Weather', workloads: OwaWorkload.Calendar },
                {
                    displayName: 'Adding or creating a new calendar',
                    workloads: OwaWorkload.Calendar,
                },
                {
                    displayName: 'Managing settings or appearance',
                    workloads: OwaWorkload.Calendar,
                },
                { displayName: 'Printing a calendar', workloads: OwaWorkload.Calendar },
                {
                    displayName: 'Calendar search',
                    workloads: OwaWorkload.Calendar,
                    emailAddresses: [
                        'owasearchfeaturecrew@service.microsoft.com',
                        'nathnovi@microsoft.com',
                    ],
                },
                { displayName: 'Reminders or notifications', workloads: OwaWorkload.Calendar },
                { displayName: 'Other calendar', workloads: OwaWorkload.Calendar },
            ],
        },
        hasQueryStringParameter(feedbackQueryParamName) && {
            displayName: 'Test Feedback Area',
            emailAddresses: [getUserConfiguration().SessionSettings.LogonEmailAddress],
            workloads: OwaWorkload.All,
            subAreas: [
                {
                    displayName: 'Test Feedback Sub Area with debug log',
                    emailAddresses: [getUserConfiguration().SessionSettings.LogonEmailAddress],
                    getDebugLogAttachmentDetails: lazyGetDebugLogAttachmentDetailsForTestArea,
                },
            ],
        },
        {
            displayName: 'Groups',
            emailAddresses: [
                'outlookwebfeedback@microsoft.com',
                'reactivegroups@service.microsoft.com',
            ],
            workloads: OwaWorkload.Mail,
            subAreas: [
                {
                    displayName: 'Conversations',
                    emailAddresses: ['owagroupsfc@service.microsoft.com'],
                },
            ],
        },
        {
            displayName: 'People',
            emailAddresses: ['outlookwebfeedback@microsoft.com'],
            workloads: OwaWorkload.All,
            subAreas: [
                {
                    displayName: 'Profile Card',
                    emailAddresses: ['ProfileCardFeedback@service.microsoft.com'],
                },
                {
                    displayName: 'Profile Card - LinkedIn integration',
                    emailAddresses: ['fastopgrowth@service.microsoft.com'],
                },
                {
                    displayName: 'People Hub – Contact Management',
                    emailAddresses: ['Opfeedbackoc@service.microsoft.com'],
                },
                {
                    displayName: 'People Favorites',
                    emailAddresses: ['Opfeedbackoc@service.microsoft.com'],
                },
            ],
        },
        {
            displayName: 'Options',
            emailAddresses: ['outlookwebfeedback@microsoft.com', 'owaframe@microsoft.com'],
            workloads: OwaWorkload.All,
        },
        {
            displayName: 'Add-ins',
            emailAddresses: ['outlookwebfeedback@microsoft.com', 'owaaddinsfeedback@microsoft.com'],
            workloads: OwaWorkload.All,
        },
        {
            displayName: 'Header',
            emailAddresses: [
                'outlookwebfeedback@microsoft.com',
                'owaframe@microsoft.com',
                'o2shellteam@microsoft.com',
            ],
            workloads: OwaWorkload.All,
        },
        {
            displayName: 'Header Panes',
            emailAddresses: ['outlookwebfeedback@microsoft.com', 'owaframe@microsoft.com'],
            workloads: OwaWorkload.All,
            subAreas: [
                {
                    displayName: 'Chat',
                    emailAddresses: [
                        'o2shellchat@microsoft.com',
                        'SkypeWebControlSWC@service.microsoft.com',
                    ],
                },
                {
                    displayName: 'Help',
                    emailAddresses: [
                        'o2shellhelp@microsoft.com',
                        'owahelppanefeedback@microsoft.com',
                    ],
                },
            ],
        },
        {
            displayName: 'To Do/Tasks',
            emailAddresses: ['outlookwebfeedback@microsoft.com', 'olktaskfeedback@microsoft.com'],
            workloads: OwaWorkload.All,
        },
        {
            displayName: 'My Day (Time Panel)',
            emailAddresses: [
                'outlookwebfeedback@microsoft.com',
                'calendarreactfeedback@service.microsoft.com',
                'timepanel@service.microsoft.com',
            ],
            workloads: OwaWorkload.All,
        },
        {
            displayName: 'Notifications',
            emailAddresses: [
                'outlookwebfeedback@microsoft.com',
                'owa_notifications@service.microsoft.com',
            ],
            workloads: OwaWorkload.All,
        },
        // filter out any conditional feedback areas
    ].filter(feedbackArea => !!feedbackArea);

export default getFeedbackConfig;

/**
 * Gets the feedback area, and the parent feedback area if it has one
 */
export function getFeedBackArea(displayName: string): FeedbackArea[] {
    const feedbackAreas = getFeedbackConfig();
    for (let f = 0; f < feedbackAreas.length; f++) {
        let feedbackArea = feedbackAreas[f];
        if (feedbackArea.displayName === displayName) {
            return [feedbackArea];
        } else {
            let subAreas = feedbackArea.subAreas ?? [];
            let subArea = subAreas.filter(area => area.displayName === displayName);
            if (subArea.length > 0) {
                return [feedbackArea, subArea[0]];
            }
        }
    }
    return [];
}
